import { defineMessages } from 'react-intl';

export default defineMessages({
    forgotEmailTitle: {
        id: 'accountManagement.views.forgot-email.title',
        defaultMessage: 'Forgot your email address?'
    },
    forgotEmailDescription: {
        id: 'accountManagement.views.forgot-email.description',
        defaultMessage: '&lt;span&gt;If you have forgotten the email address you log in with, and need assistance please contact us at &lt;a href="tel:{phoneNumberRaw}"&gt;{phoneNumber}&lt;/a&gt; Monday to Friday 7:30 am to 7:30 pm PT, and Saturday 8:00 am to 4:30 pm PT.&lt;/span&gt;'
    },
    backToLogin: {
         id: 'accountManagement.views.forgot-email.Back to Log in',
         defaultMessage: 'Back to Log in'
    }
 });